import React, { useMemo } from 'react';
import MetricCard from './MetricCard';

/**
 * Responsive grid of MetricCards.
 * @param {{
 *   metrics: Array<{ metricKey: string, label_pt?: string, label_en?: string, unit?: string, value?: number, target?: number, warningValue?: number, criticalValue?: number, higherIsBetter?: boolean }>,
 *   compact?: boolean,
 * }} props
 */
function KpiGrid({ metrics = [], compact = false }) {
  const items = useMemo(
    () =>
      metrics.filter((m) => m != null).map((m) => ({
        ...m,
        label: m.label_pt || m.label_en || m.metricKey || m.key || '',
      })),
    [metrics],
  );

  if (items.length === 0) {
    return (
      <div className="ccv2-kpi-grid-empty">
        <span>Nenhuma métrica configurada.</span>
      </div>
    );
  }

  return (
    <div className={`ccv2-kpi-grid ${compact ? 'ccv2-kpi-grid-compact' : ''}`}>
      {items.map((m, i) => (
        <MetricCard
          key={m.metricKey || m.key || i}
          label={m.label}
          value={m.value}
          unit={m.unit}
          target={m.target}
          warningValue={m.warningValue}
          criticalValue={m.criticalValue}
          higherIsBetter={m.higherIsBetter !== false}
          trend={m.trend}
          description={m.description || m.label_en || ''}
          compact={compact}
        />
      ))}
    </div>
  );
}

export default React.memo(KpiGrid);
